import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Popover, Select, Input} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import IBModal from 'Components/IBModal'

import style from './footer.sass'

@inject('store') @observer
class Footer extends Component {
  changeTimeframe = (value) => {
    if (frequencyItems.find(item => item.value === value).intraday) {
      const {algo, permissions} = this.props.store
      const permission = algo.single.data.has_coin ? 'lab.fx_intraday.use' : 'lab.equity_intraday.use'
      permissions.wrap(permission, () => this.props.store.algo.single.change('timeframe', value))
    } else {
      this.props.store.algo.single.change('timeframe', value)
    }
  }
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.algo.single.change(name, value)
  }
  render() {
    const {timeframe, take_profit, stop_loss} = this.props.store.algo.single.data
    return(
      <div styleName='wrapper'>
        <IBModal/>
        <div>
          <label>Frequency:*</label>
          {/* <Popover
            content={popovers.timeframe}
            placement='right'
            styleName='popover'
          >
            <span>
              <FontAwesomeIcon icon='question-circle'/>
            </span>
          </Popover> */}
          <Select value={timeframe} onChange={this.changeTimeframe} size='large'>
            {frequencyItems.map(item =>
              <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
            )}
          </Select>
        </div>
        <div>
          <label>Take profit:</label>
          <Popover
            content={popovers.take_profit}
            placement='right'
            styleName='popover'
          >
            <span>
              <FontAwesomeIcon icon='question-circle'/>
            </span>
          </Popover>
          <Input
            size='large'
            name='take_profit'
            type='number'
            onChange={this.handleChange}
            value={take_profit}
            addonAfter={<FontAwesomeIcon icon='percent'/>}
          />
        </div>
        <div>
          <label>Stop loss:</label>
          <Popover
            content={popovers.stop_loss}
            placement='right'
            styleName='popover'
          >
            <span>
              <FontAwesomeIcon icon='question-circle'/>
            </span>
          </Popover>
          <Input
            size='large'
            name='stop_loss'
            type='number'
            onChange={this.handleChange}
            value={stop_loss}
            addonAfter={<FontAwesomeIcon icon='percent'/>}
          />
        </div>
      </div>
    )
  }
}

const popovers = {
  timeframe: (
    <div>
      <p><b>How often you want the algo to run.</b></p>
      <div><i>Examples:</i></div>
      <ul>
        <li>Every hour</li>
        <li>Every day</li>
        <li>Every Monday</li>
      </ul>
    </div>
  ),
  take_profit: (
    <div>
      <p><b>Please specify as a percentage above/below the opening cost.</b></p>
      <div><i>Examples:</i></div>
      <ul>
        <li>10</li>
      </ul>
    </div>
  ),
  stop_loss: (
    <div>
      <p><b>Please specify as a percentage above/below the opening cost</b></p>
      <div><i>Examples:</i></div>
      <ul>
        <li>5</li>
      </ul>
    </div>
  )
}

const frequencyItems = [{
  label: 'Daily',
  value: 'every day'
}/*, {
  label: 'Hourly',
  value: 'every hour',
  intraday: true
}, {
  label: 'Minute',
  value: 'every minute',
  intraday: true
}, {
  label: 'Monthly',
  value: 'every month'
}, {
  label: 'Annual',
  value: 'every year'
}, {
  label: 'Every Monday',
  value: 'every monday'
}, {
  label: 'Every Tuesday',
  value: 'every tuesday'
}, {
  label: 'Every Wednesday',
  value: 'every wednesday'
}, {
  label: 'Every Thursday',
  value: 'every thursday'
}, {
  label: 'Every Friday',
  value: 'every friday'
}*/]

export default Footer
